
import Hero from '../components/Hero';
import {useState} from 'react';
import { useLanguage } from '../i18n/LanguageContext';
import { useGenericEffect } from '../components/UseGenericEffect';
import WhoIAm from '../content/who_i_am';
import MyJourney from '../content/my_journey';
import MissionAndValues from '../content/mission_and_values';



export default function AboutMe() {
  const { strings } = useLanguage();
  const map = {
    'who_i_am': <WhoIAm lang={strings.lang_code}/>,
    'my_journey': <MyJourney lang={strings.lang_code}/>,
    'mission_and_values': <MissionAndValues lang={strings.lang_code}/>
  };  

  function get(){
    setContent(map[document.getElementById('loadstate').textContent]);
  }
   useGenericEffect(() => { 
       get();
   }, [strings.lang_code]);
   
   const [content, setContent] = useState(map['who_i_am']);

  return (
    
    <div className="main">
      <Hero title={strings.pages.aboutMe.title} eyebrow={strings.pages.aboutMe.eyebrow}></Hero>
      <main className="page-content">
        <div className="content-container-menu" id="content-container-menu">
              <div className="menu-item" onClick={() => get()} id="who_i_am" tabIndex={0} role="button">{strings.pages.aboutMe.whoiam}</div>     
              <div className="menu-item" onClick={() => get()} id="my_journey" tabIndex={0} role="button" >{strings.pages.aboutMe.myjourney}</div>      
              <div className="menu-item" onClick={() => get()} id="mission_and_values" tabIndex={0} role="button">{strings.pages.aboutMe.mission}</div>        
        </div>      
        <div className="content-table max-centered">
              <div className="content-container">    
                  <div className="content-container-main show" id="content-container-main" >
                    {content}
                  </div>
              </div>
              <div className="hidden" id="loadstate">who_i_am</div>
       </div>
      </main>
    </div>
  );
}
